export default __webpack_public_path__ + "static/media/qrCode.f6e75db0.jpg";